import { Injectable } from '@angular/core';
import { Geolocation, PermissionStatus  } from '@capacitor/geolocation';
import { NativeGeocoder, NativeGeocoderOptions } from '@ionic-native/native-geocoder/ngx';
import { AllPopupModalExecutionServiceService } from 'src/app/shared/services/all-popup-modal-execution-service.service';

@Injectable({
  providedIn: 'root'
})
export class LatLongService {
  status!: PermissionStatus;
  
  constructor(private allPopupModalExecutionServiceService: AllPopupModalExecutionServiceService) { }
  
  async checkAndRequestLocationPermission() {
    /*
    this.status = await Geolocation.checkPermissions();    
    if (this.status.location !== 'granted') {
    const requestStatus: PermissionStatus = await Geolocation.requestPermissions();
    if (requestStatus.location !== 'granted') {
    // console.warn('Location permission not granted.');
    // Handle the case where permission is denied
    return false;
    }
    }
    return true;
    */
    
    return await Geolocation.checkPermissions().then( async(status: any) => {
      if (status?.location !== 'granted'){
        return await Geolocation.requestPermissions().then( (requestStatus: any) => {
          if (requestStatus?.location !== 'granted') return false
          return true;
        }).catch( (error: any) => {
          return error;
        });
      }
      return true;
    }).catch( (error: any) => {
      return error;
    });
  }
  
  async getLatLong(): Promise<any> {
    // if (!this.status) await this.checkAndRequestLocationPermission();
    // try {
    //   // Get user's current position
    //   const coordinates = await Geolocation.getCurrentPosition();
    //   const userLat = coordinates.coords.latitude;
    //   const userLng = coordinates.coords.longitude;
    //   return { userLat, userLng};
    // } catch (error: any) {
    //   console.error('Error getting location:', error?.message);
    //   return false;
    // }    
    
    return await this.checkAndRequestLocationPermission().then( async(permissionStatus: any) => {
      return await Geolocation.getCurrentPosition().then( (coordinates: any) => {
        return { userLat: coordinates?.coords?.latitude, userLng: coordinates?.coords?.longitude}
      }).catch( (error: any) => {
        return error;
      });
    }).catch( (error) => {
      return error;
    });
  }
}
